
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Home } from "lucide-react";
import { Link } from "react-router-dom";

export interface BreadcrumbNavProps {
  currentPage?: string;
  links?: Array<{
    label: string;
    href: string;
  }>;
}

export const BreadcrumbNav = ({ currentPage, links = [] }: BreadcrumbNavProps) => {
  return (
    <Breadcrumb className="mb-6">
      <BreadcrumbList>
        <BreadcrumbItem>
          <Link to="/" className="flex items-center gap-1 text-edgefi-purple hover:text-edgefi-purple/80">
            <Home className="h-3.5 w-3.5" />
            <span>Home</span>
          </Link>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        
        <BreadcrumbItem>
          <Link to="/case-studies" className="text-edgefi-purple hover:text-edgefi-purple/80">
            Case Studies
          </Link>
        </BreadcrumbItem>
        
        {links && links.length > 0 && links.map((item, index) => (
          <span key={index}>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <Link to={item.href} className="text-edgefi-purple hover:text-edgefi-purple/80">
                {item.label}
              </Link>
            </BreadcrumbItem>
          </span>
        ))}
        
        {currentPage && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-gray-600">{currentPage}</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
